//constants
import { LOGIN_ACTION, GOOGLE_SIGNUP_ACTION, LOGOUT,CLEAN_LOGIN_DATA } from "./Constants";

const INITIAL_STATE = {
  userDetails: {
    first_name: "",
    last_name: "",
    email: "",
    mobile: "",
    country_code: "",
    gender: "",
    birthdate: "",
    address_line_1: "",
    address_line_2: "",
    address_line_3: "",
    postal_code: "",
    state: "",
    country: "",
    timezone: "",
  },
  LOGOUT: [],
  LOGOUT_ERROR: {},

  currentUserInfo: {
    id: "",
    first_name: "",
    last_name: "",
    role_id: "",
    gender: null,
    birthdate: "",
    email: "",
    email_verification: true,
    mobile: "",
    address_line_1: null,
    address_line_2: null,
    address_line_3: null,
    postal_code: null,
    state: null,
    device_token: null,
    country_code: "",
    uuid: "",
    status: "",
    auth_method: "",
    timezone: "",
    last_login: "",
    login_attempts: 0,
    accessToken: "",
    accessTokenExpiresAt: "",
    refreshToken: "",
    refreshTokenExpiresAt: "",
    client: {
      id: "",
    },
    user: {
      id: "",
    },
    monitored_users: [],
    monitoring_users: [],
    invites: [],
    start_hour_of_day: "",
    end_hour_of_day: "",
    data_fetch_periodic_interval: "",
    data_fetch_frequency: "",
    userType: 0,
    location: "",
  },
};

export default function (state = INITIAL_STATE, action) {
  switch (action.type) {
    case LOGIN_ACTION:
      let user = action.userDetails;
      return {
        ...state,
        userDetails: {
          first_name: user.first_name ? user.first_name : "",
          last_name: user.last_name ? user.last_name : "",
          email: user.email ? user.email : "",
          mobile: user.mobile ? user.mobile : "",
          country_code: user.country_code ? user.country_code : "",
          gender: user.gender ? user.gender : "",
          birthdate: user.birthdate ? user.birthdate : "",
          address_line_1: user.address_line_1 ? user.address_line_1 : "",
          address_line_2: user.address_line_2 ? user.address_line_2 : "",
          address_line_3: user.address_line_3 ? user.address_line_3 : "",
          postal_code: user.postal_code ? user.postal_code : "",
          state: user.state ? user.state : "",
          country: user.country ? user.country : "",
          timezone: user.timezone ? user.timezone : "",
          location: user.location ? user.location : "",
        },
      };
    case GOOGLE_SIGNUP_ACTION:
      return {
        ...state,
        currentUserInfo: {
          ...state.currentUserInfo,
          id: action.response.id ? action.response.id : "",
          first_name: action.response.first_name
            ? action.response.first_name
            : "",
          last_name: action.response.last_name ? action.response.last_name : "",
          role_id: action.response.role_id ? action.response.role_id : "",
          gender: action.response.gender ? action.response.gender : null,
          birthdate: action.response.birthdate ? action.response.birthdate : "",
          email: action.response.email ? action.response.email : "",
          email_verification:
            action.response.email_verification &&
            action.response.email_verification,
          mobile: action.response.mobile ? action.response.mobile : "",
          address_line_1: action.response.address_line_1
            ? action.response.address_line_1
            : null,
          address_line_2: action.response.address_line_2
            ? action.response.address_line_2
            : null,
          address_line_3: action.response.address_line_3
            ? action.response.address_line_3
            : null,
          postal_code: action.response.postal_code
            ? action.response.postal_code
            : null,
          state: action.response.state ? action.response.state : null,
          device_token: action.response.device_token
            ? action.response.device_token
            : null,
          country_code: action.response.country_code
            ? action.response.country_code
            : "",
          uuid: action.response.uuid ? action.response.uuid : "",
          status: action.response.status ? action.response.status : "",
          auth_method: action.response.auth_method
            ? action.response.auth_method
            : "",
          timezone: action.response.timezone ? action.response.timezone : "",
          last_login: action.response.last_login
            ? action.response.last_login
            : "",
          login_attempts: action.response.login_attempts,
          accessToken: action.response.accessToken
            ? action.response.accessToken
            : "",
          accessTokenExpiresAt: action.response.accessTokenExpiresAt
            ? action.response.accessTokenExpiresAt
            : "",
          refreshToken: action.response.refreshToken
            ? action.response.refreshToken
            : "",
          refreshTokenExpiresAt: action.response.refreshTokenExpiresAt
            ? action.response.refreshTokenExpiresAt
            : "",
          client: {
            id: action.response.client.id ? action.response.client.id : "",
          },
          user: {
            id: action.response.user.id ? action.response.user.id : "",
          },
          monitored_users: action.response.monitored_users
            ? action.response.monitored_users
            : [],
          monitoring_users: action.response.monitoring_users
            ? action.response.monitoring_users
            : [],
          invites: action.response.invites ? action.response.invites : [],
          start_hour_of_day: action.response.start_hour_of_day
            ? action.response.start_hour_of_day
            : "",
          end_hour_of_day: action.response.end_hour_of_day
            ? action.response.end_hour_of_day
            : "",
          data_fetch_periodic_interval: action.response
            .data_fetch_periodic_interval
            ? action.response.data_fetch_periodic_interval
            : "",
          userType: action.response.user_type,
          location: action.response.location,
        },
      };

    case LOGOUT:
      return {
        ...state,
        LOGOUT: action.response.data ? [...action.response.data] : [],
        LOGOUT_ERROR: action.error ? { ...action.error } : {},
      };

      case CLEAN_LOGIN_DATA:
        return {
          ...state,
          currentUserInfo: {
            id: "",
            first_name: "",
            last_name: "",
            role_id: "",
            gender: null,
            birthdate: "",
            email: "",
            email_verification: true,
            mobile: "",
            address_line_1: null,
            address_line_2: null,
            address_line_3: null,
            postal_code: null,
            state: null,
            device_token: null,
            country_code: "",
            uuid: "",
            status: "",
            auth_method: "",
            timezone: "",
            last_login: "",
            login_attempts: 0,
            accessToken: "",
            accessTokenExpiresAt: "",
            refreshToken: "",
            refreshTokenExpiresAt: "",
            client: {
              id: "",
            },
            user: {
              id: "",
            },
            monitored_users: [],
            monitoring_users: [],
            invites: [],
            start_hour_of_day: "",
            end_hour_of_day: "",
            data_fetch_periodic_interval: "",
            data_fetch_frequency: "",
            userType: 0,
            location: "",
          },
        };
    
    default:
      return state;
  }
}
